import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { MapPin, Phone, Mail } from "lucide-react";
import Logo from "./Logo";

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer
      className="border-t border-white/10 bg-[#050505] mt-24"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <Logo size="lg" />
          <p className="mt-6 text-zinc-400 max-w-sm leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <p className="text-label mb-5">{t.footer.explore}</p>
          <ul className="space-y-3 text-zinc-300 text-sm">
            <li>
              <Link to="/fleet" className="hover:text-[#FFB400] transition-colors">
                {t.nav.fleet}
              </Link>
            </li>
            <li>
              <Link to="/monthly" className="hover:text-[#FFB400] transition-colors">
                Monthly · Movix at Home
              </Link>
            </li>
            <li>
              <Link to="/loyalty" className="hover:text-[#FFB400] transition-colors">
                Movix Club
              </Link>
            </li>
            <li>
              <Link to="/referral" className="hover:text-[#FFB400] transition-colors">
                Refer & earn $20
              </Link>
            </li>
            <li>
              <Link to="/welcome" className="hover:text-[#FFB400] transition-colors">
                Newcomer $30 off
              </Link>
            </li>
            <li>
              <Link to="/live" className="hover:text-[#FFB400] transition-colors">
                Live fleet
              </Link>
            </li>
            <li>
              <Link to="/business" className="hover:text-[#FFB400] transition-colors">
                Movix Business
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-label mb-5">Neighborhoods</p>
          <ul className="space-y-3 text-zinc-300 text-sm">
            <li>
              <Link to="/rental/everett" className="hover:text-[#FFB400] transition-colors">
                Everett
              </Link>
            </li>
            <li>
              <Link to="/rental/cambridge" className="hover:text-[#FFB400] transition-colors">
                Cambridge
              </Link>
            </li>
            <li>
              <Link to="/rental/east-boston" className="hover:text-[#FFB400] transition-colors">
                East Boston
              </Link>
            </li>
            <li className="pt-2 border-t border-white/5"></li>
            <li>
              <Link to="/about" className="hover:text-[#FFB400] transition-colors">
                {t.nav.about}
              </Link>
            </li>
            <li>
              <Link to="/press" className="hover:text-[#FFB400] transition-colors">
                Press
              </Link>
            </li>
            <li>
              <Link to="/guide/driving-usa" className="hover:text-[#FFB400] transition-colors">
                Driving in the US guide
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-[#FFB400] transition-colors">
                {t.nav.contact}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-label mb-5">{t.footer.contact}</p>
          <ul className="space-y-3 text-zinc-300 text-sm">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-1 text-[#FFB400]" />
              <span>{t.contact.address}</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-[#FFB400]" />
              <span>{t.contact.phoneLabel}</span>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#FFB400]" />
              <span>movixcarrental@gmail.com</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-500 font-mono-ui tracking-widest uppercase">
            © {new Date().getFullYear()} Movix Car Rental. {t.footer.rights}
          </p>
          <p className="text-xs text-zinc-600 font-mono-ui tracking-widest uppercase">
            Everett · Greater Boston · MA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
